import AuthenticationStore from '../store/authenticationStore';

export class LogoutModel {
  
  /**
   * @type {string|undefined}
   */
  refreshToken = AuthenticationStore.getRefreshToken();
  
}
